import { combineReducers } from 'redux';
import ParcelReducer from './Parcels/ParcelsReducer';

const rootReducer = combineReducers({
  ParcelReducer
});

export default rootReducer;
